import { Grid } from 'antd';

const { useBreakpoint } = Grid;

/**
 * True on phone-sized viewports (< 768px, AntD's `md` breakpoint). Portretul
 * unui telefon (ex. S26 Ultra ≈ 480px CSS) intră aici; landscape-ul lat sau
 * tabletele/desktop-ul nu. Un singur breakpoint pentru tot UI-ul, ca deciziile
 * „mobil vs. desktop" să fie luate într-un singur loc și nu împrăștiate în
 * `@media` prin cod.
 *
 * `useBreakpoint()` returnează `{}` la primul render (înainte să se rezolve
 * media queries), deci `!screens.md` e `true` tranzitoriu — acceptabil: pornim
 * din layout-ul de mobil și „urcăm" la desktop când breakpoint-ul se rezolvă,
 * fără flash de conținut tăiat.
 */
export function useIsMobile(): boolean {
  const screens = useBreakpoint();
  return !screens.md;
}

/**
 * Lățimea unui Drawer de formular: full-screen pe mobil (altfel `clamp(...)`-ul
 * desktop, cu minim ~560px, e mai lat decât ecranul telefonului și iese din
 * viewport), lățimea desktop primită ca argument în rest.
 */
export function drawerWidth(isMobile: boolean, desktop: number | string): number | string {
  return isMobile ? '100%' : desktop;
}

/**
 * Lățimea unui Modal: aproape full pe mobil (`calc(100vw - 32px)` lasă o mică
 * margine ca modalul să nu lipească de marginile ecranului), lățimea desktop în
 * rest.
 */
export function modalWidth(isMobile: boolean, desktop: number | string): number | string {
  return isMobile ? 'calc(100vw - 32px)' : desktop;
}
